export default "__VITE_ASSET__DcdD$zkZ__"